import { FiglioList, ParentVM } from 'civil-status/view-models/step-form';

export const transformerFiglioList = (
  subjects?: Array<ParentVM>
): Array<FiglioList> | undefined => {
  if (subjects?.length === 0) {
    return undefined;
  }

  return subjects?.map((item) => {
    return {
      key: {
        idSoggetto: item?.generality?.idSubject || null,
      },
      nuovoCognome: item.generality?.newSurname || undefined,
      idAnsc: item.generality?.idActDigital || undefined,
      idAttoCartaceo: item.generality?.idActPaper || undefined,
      nomeComuneRegistrazione: item?.generality?.italianAct?.municipality?.description || undefined,
      idComuneRegistrazione: item?.generality?.italianAct?.municipality?.code || undefined,
      idProvinciaRegistrazione: item?.generality?.italianAct?.municipality?.idProvince || undefined,
      siglaProvinciaRegistrazione:
        item?.generality?.italianAct?.municipality?.province || undefined,
      codiceSoggetto: item?.codeSubject || undefined,
    } as FiglioList;
  });
};
